import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-flued h-100" }
const _hoisted_2 = {
  key: 0,
  class: "w-100"
}
const _hoisted_3 = { class: "w-100 h-100" }

import { onMounted, ref } from "vue";
import "brace";
import "brace/mode/javascript";
import "brace/mode/html";
import "brace/theme/chrome";
import { GlobalImport } from "../../utils/GlobalImport";
import { blocklyStore } from "../../blockly/blocklyStore";
import { StringUtils } from "../../utils/StringUtils";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { Permission } from '../../utils/Permission';

export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlSection',
  setup(__props) {

const ace = GlobalImport.getAce();
/**
 * エディタ生成
 */
const editor = ref(null);
onMounted(() => {
  editor.value = ace.edit("html_editor");
  editor.value.getSession().setMode("ace/mode/html");
  editor.value.setTheme("ace/theme/chrome");
  editor.value.setFontSize(18);
  editor.value.focus();
  editor.value.setReadOnly(true);
  const html = blocklyStore.builder.workspaceToCode;
  // html = html;
  // console.log(html);
  editor.value.setValue(html);
});

const onEditorKeyDown = () => {
  MessageDialog.alert("このエディタは読み取り専用です");
};

const sanitize = () => {
  let html = blocklyStore.builder.workspaceToCode;
  html = StringUtils.htmlEncode(html);
  editor.value.setValue(html);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(Permission).onlyAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-info btn-lg",
            onClick: sanitize
          }, "HTMLの不要属性を除去する")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        id: "html_editor",
        class: "h-100 w-100",
        onKeydown: onEditorKeyDown
      }, null, 32)
    ])
  ]))
}
}

})